module.exports = function (obj) {   

    var isNull = (obj == undefined || obj == "undefined" || obj == null || obj == "") ? true : false;     
    return isNull;    
    
}